var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"page-footer":true,"add-href":"","search-url":_vm.url,"tableTitle":_vm.tableTitle,"add":false,"refresh":false,"setting":false,"rightBtn":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }